import * as React from "react";
import { Typography } from "@mui/material";

import { Address, Country } from "../models";
import { ProfileAddressPlaceholder } from "./profileAddressPlaceholder";
import { useAppSelector } from "hooks/reduxHooks";
import FeatureToggleChecker from "modules/utils/featureToggleChecker";

export interface ProfileAddressViewProps {
    address: Address;
    countries: Country[];
    isLoading: boolean;
}

export const ProfileAddressView = (props: ProfileAddressViewProps) => {
    const hideSuiteNumberToggleFeature = useAppSelector(state => state.features.featureToggles.HideSuiteNumber);
    const showSuiteNumber = !FeatureToggleChecker.isOn(hideSuiteNumberToggleFeature);
   
        return (
            <Typography variant="subtitle1" gutterBottom>
                {props.isLoading ? (
                    <ProfileAddressPlaceholder />
                ) : props.address ? (
                    <div>
                        <div>
                            {showSuiteNumber && <span>{props.address.suiteNumber ? <span id="suite-number">{props.address.suiteNumber}-</span> : null}</span>}
                            <span>{props.address.street ? <span id="street-address">{props.address.street}</span> : null}</span>
                        </div>
                        <div>
                            <span>{props.address.city ? <span id="city">{props.address.city}, &nbsp;</span> : null}</span>
                            <span>{props.address.province ? <span id="province">{props.address.province} &nbsp;</span> : null}</span>
                            <span>{props.address.postalCode ? <span id="postal-code">{props.address.postalCode.toUpperCase()}</span> : null}</span>
                        </div>
                        <div>
                            <span>{props.address.country ? <span id="country">{props.address.country}</span> : null}</span>
                        </div>
                    </div>
                ) : (
                    <Typography variant="caption">Not set</Typography>
                )}
            </Typography>
        );
    
}
